import { render, staticRenderFns } from "./PublisherPluginStatus.vue?vue&type=template&id=ec40ef42&"
import script from "./PublisherPluginStatus.vue?vue&type=script&lang=js&"
export * from "./PublisherPluginStatus.vue?vue&type=script&lang=js&"
import style0 from "./PublisherPluginStatus.vue?vue&type=style&index=0&id=ec40ef42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports